import { eventInviteUrl } from "./eventLinks";
import { pricingPillLabel, currencySymbol } from "./format";
import { resolveEffectivePricing } from "./pricing";

export function formatShareDate(iso, { style = "long" } = {}) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (style === "short") {
      return d.toLocaleString("en-GB", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      });
    }
    return d.toLocaleString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/** WhatsApp-friendly blurb with the key event details + RSVP link. */
export function buildEventWhatsAppSummary(event, { link, counts } = {}) {
  const inviteLink = link || eventInviteUrl(event);
  const c = counts || event?.counts;
  const lines = [
    `*${event.name}*`,
    formatShareDate(event.starts_at),
    event.location,
  ];

  const resolved = resolveEffectivePricing(event.pricing, { rsvpCount: c?.total });
  const price = pricingPillLabel(resolved);
  if (price && price !== "FREE") {
    lines.push(price);
    if (resolved.early_bird_active) {
      const sym = currencySymbol(resolved.currency);
      lines.push(`   (regular ${resolved.amount}${sym})`);
    }
  }

  if (c && typeof c.total === "number") {
    lines.push(
      `${c.total} going · ${Math.round(c.balanced_leaders)} leaders · ${Math.round(c.balanced_followers)} followers`,
    );
  }

  lines.push("", `RSVP here: ${inviteLink}`);
  return lines.join("\n");
}

export function openWhatsAppShare(text) {
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}

export async function copyWhatsAppSummary(text) {
  await navigator.clipboard.writeText(text);
}
